
import React from 'react';

interface ColorsIconProps extends React.SVGProps<SVGSVGElement> {}

const ColorsIcon: React.FC<ColorsIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a9 9 0 100 18 9 9 0 000-18z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5S16.5 14.485 16.5 12 14.485 7.5 12 7.5z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1.5M12 19.5V21M3 12h1.5M19.5 12H21M5.636 5.636l1.06 1.06M17.303 17.303l1.061 1.061M5.636 18.364l1.06-1.06M17.303 6.697l1.061-1.061" />
  </svg>
);

export default ColorsIcon;
